import React from 'react'

const Footer = () => (
  <div
    style={{
      fontSize: '14px',
      padding: '0 1.5rem 0.75rem',
      textAlign: 'center',
    }}
  >
    &copy;2018 Chris Deaton
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js